export const CustomTooltip = ({ active, payload, label }: any) => {
  if (active && payload && payload.length) {
    return (
      <div className="rounded-xl border border-neutral-800 bg-neutral-950/95 p-2.5 shadow-2xl backdrop-blur-md text-xs pointer-events-none select-none z-50">
        <div className="font-semibold text-neutral-200 mb-1.5">{label}</div>
        {payload.map((entry: any, index: number) => {
          let suffix = "";
          if (entry.name?.includes("Расход") || entry.dataKey === "spent" || entry.dataKey === "cpa") {
            suffix = " ₽";
          } else if (entry.name?.includes("Клики") || entry.dataKey === "clicks") {
            suffix = " кликов";
          } else if (entry.name?.includes("CTR") || entry.dataKey === "ctr") {
            suffix = "%";
          }

          const valFormatted =
            typeof entry.value === "number"
              ? entry.value.toLocaleString("ru-RU")
              : entry.value;

          return (
            <div
              key={index}
              className="flex items-center justify-between gap-4 py-0.5"
            >
              <div className="flex items-center gap-1.5">
                <span
                  className="w-2 h-2 rounded-full shrink-0"
                  style={{ backgroundColor: entry.color }}
                />
                <span className="text-neutral-400">{entry.name}:</span>
              </div>
              <span className="font-medium text-neutral-100 whitespace-nowrap">
                {valFormatted}
                {suffix}
              </span>
            </div>
          );
        })}
      </div>
    );
  }
  return null;
};

